function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Descriptions, Table, Button, Drawer } from 'antd';
import { Container, Row, Col } from 'react-bootstrap';
import Moment from 'react-moment';
import { CheckCircle } from 'react-bootstrap-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var OrderDetailsView = function OrderDetailsView(_ref) {
  var order = _ref.order;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    settlementArrayData = _useState2[0],
    setSettlementArrayData = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    drArrayData = _useState4[0],
    setDrArrayData = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedSettlement = _useState6[0],
    setSelectedSettlement = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedDr = _useState8[0],
    setSelectedDr = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isSettlementProofVisible = _useState10[0],
    setIsSettlementProofVisible = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isDrProofVisible = _useState12[0],
    setIsDrProofVisivle = _useState12[1];
  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Montant (GNF)"
    }),
    dataIndex: 'amount',
    key: 'amount',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Date"
    }),
    dataIndex: 'date',
    key: 'date',
    render: function render(text) {
      return /*#__PURE__*/_jsx(Moment, {
        date: text,
        format: "DD/MM/YYYY"
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Commentaire"
    }),
    dataIndex: 'comment',
    key: 'comment',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Justif."
    }),
    dataIndex: 'settlement',
    key: 'settlement',
    render: function render(settlement) {
      return /*#__PURE__*/_jsx(Button, {
        type: "link",
        onClick: function onClick() {
          setSelectedSettlement(settlement);
          setIsSettlementProofVisible(true);
        },
        children: /*#__PURE__*/_jsx("b", {
          children: "VOIR LA PIECE"
        })
      });
    }
  }];
  var dcols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Date"
    }),
    dataIndex: 'date',
    key: 'date',
    render: function render(text) {
      return /*#__PURE__*/_jsx(Moment, {
        date: text,
        format: "DD/MM/YYYY"
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Quantit\xE9"
    }),
    dataIndex: 'received_quantity',
    key: 'received_quantity',
    render: function render(text) {
      return /*#__PURE__*/_jsxs("span", {
        children: [text.toLocaleString('Fr'), " Litres"]
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "BL"
    }),
    dataIndex: 'dr',
    key: 'dr',
    render: function render(dr) {
      return /*#__PURE__*/_jsx(Button, {
        type: "link",
        onClick: function onClick() {
          setSelectedDr(dr);
          setIsDrProofVisivle(true);
        },
        children: /*#__PURE__*/_jsx("b", {
          children: "VOIR LE BL"
        })
      });
    }
  }];
  useEffect(function () {
    setSettlementArrayData([]);
    setDrArrayData([]);
    order.settlements.forEach(function (s) {
      setSettlementArrayData(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          key: s.id,
          amount: s.amount,
          comment: s.comment,
          date: s.created_at,
          settlement: s
        }]);
      });
    });
    order.delivery_reports.forEach(function (dr) {
      setDrArrayData(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          key: dr.id,
          date: dr.created_at,
          received_quantity: dr.received_quantity,
          dr: dr
        }]);
      });
    });
  }, [order]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          lg: 8,
          md: 9,
          children: [/*#__PURE__*/_jsxs(Descriptions, {
            bordered: true,
            title: /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsxs("b", {
                children: ["COMMANDE N\xBA", order.id, " DU ", /*#__PURE__*/_jsx(Moment, {
                  date: order.created_at,
                  format: "DD/MM/YYYY"
                })]
              })
            }),
            extra: order.status == 0 ? /*#__PURE__*/_jsx(Button, {
              type: "primary",
              style: {
                background: "#CA5656"
              },
              onClick: null,
              children: /*#__PURE__*/_jsx("b", {
                children: "CONFIRMER"
              })
            }) : /*#__PURE__*/_jsx(CheckCircle, {
              size: 22,
              style: {
                color: '#58AF6A'
              }
            }),
            column: 2,
            children: [/*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "Produit"
              }),
              children: order.product.label
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "Fournisseur"
              }),
              children: order.provider.label
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "Station"
              }),
              children: order.gas_station.label
            }), /*#__PURE__*/_jsxs(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "Quantit\xE9 command\xE9e "
              }),
              children: [order.quantity.toLocaleString('Fr'), " Litres"]
            }), /*#__PURE__*/_jsxs(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "Quantit\xE9 livr\xE9e"
              }),
              children: [order.delivered_quantity.toLocaleString('Fr'), " Litres"]
            }), /*#__PURE__*/_jsxs(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "Total Pay\xE9"
              }),
              children: [order.paid_amount.toLocaleString('Fr'), " GNF"]
            })]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h6", {
            children: /*#__PURE__*/_jsx("b", {
              children: "HISTORIQUE PAIEMENTS"
            })
          }), /*#__PURE__*/_jsx(Table, {
            bordered: true,
            size: "small",
            pagination: false,
            columns: cols,
            dataSource: settlementArrayData
          })]
        }), /*#__PURE__*/_jsxs(Col, {
          lg: 4,
          md: 3,
          children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h6", {
            children: /*#__PURE__*/_jsx("b", {
              children: "HISTORIQUE LIVRAISONS"
            })
          }), /*#__PURE__*/_jsx(Table, {
            bordered: true,
            size: "small",
            pagination: false,
            columns: dcols,
            dataSource: drArrayData
          })]
        })]
      })
    }), selectedSettlement != null && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "PIECE JUSTIFICATIVE"
        }),
        width: "380px",
        open: isSettlementProofVisible,
        onClose: function onClose() {
          setIsSettlementProofVisible(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx("img", {
          src: selectedSettlement.proof,
          style: {
            width: '95%'
          }
        })
      })
    }), selectedDr != null && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: "BON DE LIVRAISON"
      }),
      width: "380px",
      open: isDrProofVisible,
      onClose: function onClose() {
        setIsDrProofVisivle(false);
      },
      destroyOnClose: true,
      children: /*#__PURE__*/_jsx("img", {
        src: selectedDr.proof,
        style: {
          width: '95%'
        }
      })
    })]
  });
};
export default OrderDetailsView;